import { ValueBlockProps } from './type';

interface Props {
  blockProps: ValueBlockProps;
  scaleFactor?: number;
}

export const ValueBlock: React.FC<Props> = ({
  blockProps,
  scaleFactor = 1,
}) => {
  const {
    value,
    isBold,
    width,
    isItalics,
    fontSize,
    alignment,
    border,
    isCapsLocks,
    color,
    mappingKey,
  } = blockProps;
  return (
    <div
      style={{
        fontSize: `${fontSize * scaleFactor}px`,
        fontWeight: isBold ? '600' : 'normal',
        fontStyle: isItalics ? 'italic' : 'normal',
        textAlign: alignment,
        width: `${width * scaleFactor}px`,
        textTransform: isCapsLocks ? 'uppercase' : 'none',
        overflow: 'clip',
        borderLeft: border?.left
          ? `${border.width * scaleFactor}px ${border.style}`
          : 'none',
        borderRight: border?.right
          ? `${border.width * scaleFactor}px ${border.style}`
          : 'none',
        borderTop: border?.top
          ? `${border.width * scaleFactor}px ${border.style}`
          : 'none',
        borderBottom: border?.bottom
          ? `${border.width * scaleFactor}px ${border.style}`
          : 'none',
        color: color ?? '#000000',
      }}
    >
      {/* When there is no text, something should be printed so that the borderBottom doesn't move up */}
      {value ?? (
        <div
          style={{
            color: 'white',
          }}
        ></div>
      )}
    </div>
  );
};
